import { useAppSelector } from '@store/hooks';
import { useSearchStandingOrderMutation } from '@store/rtk/rides';
import { selectHomePageModalSearch } from '@store/slices/search/homeSearchSlice';
import { useEffect, useRef, useState } from 'react';
import { useForm } from '@hooks/useDirtyForm';
import {
  defaultValues,
  FormTypes,
} from '@src/modals/HomeModals/SOSearchModal/constants';
import { useWatch } from 'react-hook-form';
import { useDebouncedValue } from '@hooks/useDebouncedValue';
import { idType } from '@src/types';
import { encrypt } from '@src/utils';
import { ContractorSearchFormValues } from '@hooks/useContractorSearch';

function buildFilters(
  values: Partial<ContractorSearchFormValues>
): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(values)) {
    if (value === null || value === undefined || value === '') continue;
    result[key] = value;
  }

  return result;
}

export const useStandingOrderSearch = () => {
  const SEARCH_RIDE_PAGE_SIZE = 20;
  const prevFiltersRef = useRef<string>('');

  const [searchStandingOrder, { isLoading }] = useSearchStandingOrderMutation();

  const { searchSOData } = useAppSelector(selectHomePageModalSearch);

  const [filters, setFilters] = useState<Record<string, string>>({});

  const { control } = useForm<FormTypes>({
    defaultValues,
    mode: 'onChange',
  });

  const watchedFormValues = useWatch<FormTypes>({ control });
  const debouncedValues = useDebouncedValue<FormTypes>(
    watchedFormValues as FormTypes,
    500
  );

  useEffect(() => {
    const cleanedValues = buildFilters(
      debouncedValues as Partial<ContractorSearchFormValues>
    ) as any;

    const serialized = JSON.stringify(cleanedValues);
    if (serialized === prevFiltersRef.current) return;

    prevFiltersRef.current = serialized;
    setFilters(cleanedValues);

    searchStandingOrder({
      argument: { body: cleanedValues },
      params: { size: SEARCH_RIDE_PAGE_SIZE },
    });
  }, [debouncedValues, searchStandingOrder]);

  const handleClickEdit = (id: idType) => {
    const encodeId = encrypt({ ['standingOrder']: id });

    window.open(`/standing-order/details/${encodeId}`, '_blank');
  };

  return {
    control,
    filters,
    searchSOData,
    handleClickEdit,
    isLoading,
  };
};
